module.exports = __webpack_public_path__ + "media/img/favicon/safari-pinned-tab-b573c72663842d8a2563075f36b255af.svg";